import { motion } from "framer-motion"
import { useState } from "react"
import {spring} from "../../../lib/styling/animations"

export type PhoneNumber = {
  friendlyName: string
  phoneNumber: string
  locality?: string
  region?: string
  cost: string
  webHooksLinked?: boolean
}

export type TwilioAvailableNumbersProps = {
  numbers: PhoneNumber[]
  onPurchase: (phoneNumber: string) => unknown
  showLocationData?: boolean
}

export default function TwilioAvailableNumbers({
  numbers = [],
  onPurchase,
  showLocationData,
}: TwilioAvailableNumbersProps): JSX.Element {
  const [confirmingPurchase, setConfirmingPurchase] = useState<string[]>([])

  return (
    <div className="flex flex-col py-4 items-start w-full">
      <h2>Available Phone Numbers</h2>
      {numbers.length === 0 ? (
        <span className="w-full text-center text-lg text-ppt-caution">
          {"Sorry, there were no results."}
        </span>
      ) : null}
      {numbers.map(({ friendlyName, phoneNumber, locality, region, cost }) => (
        <motion.div
          className={
            "grid bg-ppt-blue-900 mt-2 w-full " +
            (showLocationData ? " grid-cols-3" : " grid-cols-2")
          }
          layout
          transition={spring}
          key={phoneNumber}
        >
          <span className="p-2">{friendlyName}</span>
          {showLocationData ? (
            <span className="p-2">{`${
              locality ? locality + "," : ""
            }${region}`}</span>
          ) : null}
          {confirmingPurchase.some((number) => number === phoneNumber) ? (
            <div className="p-2 flex flex-col">
              <span className="text-sm">
                {`Your Twilio account will be charged ${cost} / month for this number. Confirm this puchase?`}
              </span>
              <div className="flex w-full items-center justify-end">
                <button
                  onClick={() => onPurchase(phoneNumber)}
                  className="font-display text-sm text-ppt-red mr-4 hover:text-ppt-caution"
                >
                  yes
                </button>
                <button
                  onClick={() =>
                    setConfirmingPurchase((prev) =>
                      prev.filter((number) => number !== phoneNumber)
                    )
                  }
                  className="font-display text-sm text-ppt-blue hover:text-ppt-success"
                >
                  no
                </button>
              </div>
            </div>
          ) : (
            <span className="py-2 px-4 flex items-center justify-between">
              {cost}
              {" per month"}
              <button
                onClick={() =>
                  setConfirmingPurchase((prev) => [...prev, phoneNumber])
                }
                className="font-display text-ppt-success border-b-2 border-transparent hover:border-ppt-success"
              >
                purchase
              </button>
            </span>
          )}
        </motion.div>
      ))}
    </div>
  )
}